import React from 'react';
import { Spinner, UIHeading4 } from '@cian/ui-kit';

import styles from './styles.css';

export const LoaderBlock: React.FC = () => {
  return (
    <div className={styles['root']}>
      <Spinner size={20} />
      <div className={styles['title']}>
        <UIHeading4>Загружаем предложения от застройщика и банков</UIHeading4>
      </div>
    </div>
  );
};

LoaderBlock.displayName = 'LoaderBlock';
